module.exports = __webpack_public_path__ + "static/media/icon_less_than.5cfc4fd2.svg";